import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import type {
	SchedulerAiCronGenerateResult,
	SchedulerAiCronGenerator,
} from '@framework/analytics/components/scheduler/scheduler-ai-cron.port';
import { JepRequestService } from '@jepto/shared/services/jep-request/jep-request.service';
import { isErrorExistingFromGQLResponse } from '@jepto/shared/utils/collection';
import { MUTATION_GENERATE_CRON_EXPRESSION } from './generate-cron-expression.mutation';

@Injectable({ providedIn: 'root' })
export class SchedulerAiCronAppSyncService implements SchedulerAiCronGenerator {
	constructor(private readonly requestService: JepRequestService) {}

	generate(prompt: string): Observable<SchedulerAiCronGenerateResult> {
		return this.requestService
			.mutate({
				mutation: MUTATION_GENERATE_CRON_EXPRESSION,
				variables: { prompt },
			})
			.pipe(
				switchMap((gqlResponse: any) => {
					if (isErrorExistingFromGQLResponse(gqlResponse)) {
						const msg =
							gqlResponse.errors?.[0]?.message ?? 'GraphQL error';
						return throwError(() => new Error(msg));
					}
					const block = gqlResponse.data?.generateCronExpression;
					const raw = block?.expression;
					const expression =
						raw == null ? '' : String(raw).trim();
					if (!expression) {
						return throwError(
							() => new Error('No expression returned')
						);
					}
					const descRaw = block?.description;
					const description =
						descRaw == null
							? undefined
							: String(descRaw).trim() || undefined;
					return of({ expression, description });
				})
			);
	}
}
